import * as React from "react";
import { Box, styled } from "@mui/system";
import { Typography } from "@mui/material";
import { useState, useRef, useEffect } from "react";
import entryImage from "../../../../assets/entryImageTemp.jpg";
import useWindowSize from "../../../../utils/useWindowSize";

const ParallaxComponent = ({ height = "100vh", image, title }) => {
  const [offset, setOffset] = useState(0);
  const contentRef = useRef(null);
  const { width } = useWindowSize();

  let imageHeight = 2000;
  if (width >= 500 && width < 1000) {
    imageHeight = 1700;
  } else if (width >= 1000 && width < 1500) {
    imageHeight = 1400;
  } else if (width >= 1500 && width < 2000) {
    imageHeight = 1100;
  } else if (width >= 2000 && width < 2500) {
    imageHeight = 800;
  } else if (width >= 2500 && width < 3000) {
    imageHeight = 500;
  }
  useEffect(() => {
    const handleScroll = () => {
      if (contentRef.current) {
        const rect = contentRef.current.getBoundingClientRect();
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const scrollPercentage = (scrollTop - rect.top) / (rect.height - window.innerHeight);
        const newOffset = scrollPercentage * 50; // Adjust the multiplier for the desired effect
        setOffset(newOffset);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <StyledParallaxContainer height={height}>
      <StyledParallaxImage
        offset={offset}
        sx={{
          height: imageHeight,
          backgroundImage: `url(${image})`,
        }}
      />
      <StyledContentContainer height={height} ref={contentRef}>
        <Typography variant='h2'>{title}</Typography>
      </StyledContentContainer>
    </StyledParallaxContainer>
  );
};

const StyledParallaxContainer = styled(Box)(({ height, theme }) => ({
  position: "relative",
  height: height,
  overflow: "hidden",
}));

const StyledParallaxImage = styled(Box)(({ theme, offset }) => {
  return {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    backgroundImage: `url(${entryImage})`, // Replace with your actual image URL
    backgroundSize: "cover",
    backgroundPosition: "center",
    // Prevent the image from repeating
    backgroundRepeat: "no-repeat",
    zIndex: -1,
    pointerEvents: "none",
    willChange: "transform",
    transform: "translateZ(0)",
    backgroundPositionY: `${offset}%`,
  };
});

const StyledContentContainer = styled(Box)(({ height, theme }) => ({
  padding: theme.spacing(1),
  position: "relative",
  zIndex: 0,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: height,
}));

export default ParallaxComponent;
